import func from '../common/function';
import cd from '../data/cluster-data';
import ci from '../data/cluster-info';
import ia from './index-alias';
import ni from '../data/node-index';
import io from './index-optimize';
import iny from './index-analyser';
import id from './index-delete';

let uiCluster = {
  bindOverview : ()=>{
    uiCluster.bindIndices().bindNodes().filterFocus();
  },
  bindIndices : ()=>{
    let $indices = $('table.ui-cluster-index');
    if(!$indices.length){
      $indices = $(`<table class="ui-cluster-index"><thead><tr><th></th></tr></thead></table>`);
      $indices.find('thead>tr>th').eq(0).append(func.filterInput(cd.cluster.indices.map(x=>x.name)));
      $('main').append($indices);
    } else {
      $indices.find('thead>tr').html('<th></th>');
    }
    cd.cluster.indices.forEach((t,i)=>{
      let $index = $(`<dl></dl>`).append($(`<dt><p title="${t.name}">${t.name}</p></dt>`).append(func.dropdown([
        {title:'Index Info' },
        {title:'status', action: ()=>{func.openJson(t.name, t.info)}},
        {title:'metadata', action: ()=>{func.openJson(t.name, t.metadata)}},
        {title:'Actions'},
        {title:'New Alias', action :()=>{ia.addAlias(t);}},
        {title:'Refresh', action :()=>{ ni.refresh(t.name); }},
        {title:'Flush', action :()=>{ ni.flush(t.name); }},
        {title:'Optimize', action :()=>{ io.exeOptimize(t.name); }},
        {title:'Gateway Snapshot', action :()=>{ ni.gatewaySnapshot(t.name); }}, // The _gateway/snapshot API has been removed.
        {title:'Test Analyser', action :()=>{ iny.exeAnalyser(t.name) }},
        {title:'Close', action :()=>{ ni.state(t.name) }, toggle: true},
        {title:'Delete', action :()=>{ id.exeDelete(t.name) }}
      ])));
      if(t.metadata.state === 'open'){
        $index.append($(`<dd class="size">${func.byteSize(t.info.total.store.size_in_bytes)}</dd>`))
        .append($(`<dd class="docs">${t.info.total.docs.count}</dd>`))
        .append($(`<dd class="alias"></dd>`).append(ia.aliasList(t.name, t.metadata.aliases)));
      }else{
        $index.append($(`<dd class="closed">closed index</dd>`));
        $index.find('.tgl-state-menu').text('Open');
      }
      $indices.find('thead>tr').append($(`<th></th>`).attr('data-name', t.name).append($index));
    });
    return uiCluster;
  },
  bindNodes : ()=>{
    let $clusters = $('.ui-cluster-index');
    if(!$clusters.find('tbody').length){
      $clusters.append('<tbody></tbody>');
    } else {
      $clusters.find('tbody').html('');
    }   
    $.each(cd.cluster.nodes, (i,v)=>{
      let $nodes = $(`<tr></tr>`),
          $node = $(`<th>${v.name}</th>`);
      if(v.master_node) {
        $node.addClass('master');
      } else if(v.ephemeral_id === 'unassigned'){
        $node.addClass('unassigned');
      } else {
        $node.addClass('slave');
      }
      (v.ephemeral_id !== 'unassigned') && $node.append(func.dropdown([
        // {title:'Node Info' },
        {title:'Cluster Node Info', action: ()=>{func.openJson('Cluster Node Info', ci.nodes.info(i))}},
        {title:'Node Stats', action: ()=>{func.openJson('Node Stats', ci.nodes.stats(i))}},
        /* {title:'Actions'},
        {title:'Shutdown', action :()=>{ console.log(this); }} // The _shutdown API has been removed. */
      ]));
      $nodes.append($node);
      cd.cluster.indices.forEach(shards=>{
        let $shards = $(`<td></td>`),
            shardcnt = 0;
        v.node[shards.name] &&
        $.each(v.node[shards.name].shards, (n, shard)=>{
          while(shardcnt < shard.shard){
            $shards.append(`<span class="shard trunc"></span>`);
            ++shardcnt;
          }
          let $shard = $(`<span class="shard state-${shard.state} ${shard.primary && 'primary'}">${shard.shard}</span>`);
          $shard.click(()=>{func.openJson(shards.name, shard);});
          $shards.append($shard);
          $shards.attr('data-name', shard.index);
          ++shardcnt;
        });
        $nodes.append($shards);
      });
      $clusters.append($nodes);
    });
    return uiCluster;
  },
	filterFocus : ()=>{
  	    $('input.filter-input').focus();
	}
}

export default uiCluster;


// WEBPACK FOOTER //
// ./src/scripts/ui/cluster.js